import AppBaseStore from './baseStore'
import { useDjango } from '@/composables/useDjango'
import type { BaseStoreActions, BaseStoreType } from '@/types/storeTypes'
import API from '@/api/apiUrls'
import { storeToRefs } from 'pinia'
import type { GroundInvestigationPoint } from '@/stores/type/giPoint.type'
import { useSectionLinesStore } from '@/stores/sectionLine'
import type { GTLPSectionVisualisation } from '@/stores/type/sectionVisualisation'

const { api } = useDjango()
const snackbarStore = useSnackbarStore()
const projectStore = useProjectStore()
type State = BaseStoreType<GTLPSectionVisualisation>
const baseUrl = API.SECTION_GEO_DATA.SECTION_LINES.INDEX
const baseStore: BaseStoreType<GTLPSectionVisualisation> = new AppBaseStore(
  baseUrl,
  api,
  snackbarStore
)
const baseStoreActions: BaseStoreActions<GTLPSectionVisualisation> = baseStore.actions
const { lengthProfileGraphBar } = storeToRefs(projectStore)
export const useSectionLineVisualisationStore = defineStore({
  id: 'sectionLineVisualisation',
  state: (): State => ({
    ...baseStore.state,
    yAxisRange: [0, 20]
  }),
  actions: {
    ...baseStoreActions,
    setYAxisRange(range: number[]) {
      this.yAxisRange = range
    },
    async createVisualisation(rasterFileIds: number[]) {
      if (lengthProfileGraphBar.value.shown) {
        const sectionLinesStore = useSectionLinesStore()
        const { visualiseItem: visualiseSectionLine } = storeToRefs(sectionLinesStore)
        this.writeLoading = true
        const body: {
          gi_points: number[]
          raster_files: number[]
        } = {
          gi_points: sectionLinesStore
            .giPointsBySectionLineId(visualiseSectionLine?.value?.id)
            .map((item: GroundInvestigationPoint) => item.id),
          raster_files: rasterFileIds
        }
        try {
          const visualiseItemId = visualiseSectionLine?.value?.id
          const uploadUrl =
            API.SECTION_GEO_DATA.SECTION_LINES.INDEX +
            `${visualiseSectionLine?.value?.id}/visualise/`
          const params = new URLSearchParams({ data: JSON.stringify(body) }).toString()
          const url = `${uploadUrl}?${params}`
          const responseData = await api.apiService.api(url, 'GET')
          if (visualiseItemId !== visualiseSectionLine?.value?.id) {
            return
          }
          this.setCurrentItem(responseData)
        } catch (e) {
          this.setSnackbarMessage('Create item failed.', 'error')
          console.error(e)
          this.writeLoading = false
          return false
        }
        this.writeLoading = false
      }
    }
  },
  getters: {
    ...baseStore.getters,
    profileDistanceCorrection(): number {
      const sectionLinesStore = useSectionLinesStore()
      const { visualiseItem: visualiseSectionLine } = storeToRefs(sectionLinesStore)
      if (visualiseSectionLine.value?.properties?.section_type === 'CrossSection') {
        return -200
      }
      return 0
    }
  }
})
